/**
 * Created by or_p on 7/7/2016.
 */
import React, { Component } from 'react';
import BaseElementDialog from '../BaseElementDialog/BaseElementDialog';
import _ from 'lodash';
import { getElementMethods } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';

export default class HtmlDialog extends Component {
  constructor(props) {
    super(props);

    this.getElementProps = this.getElementProps.bind(this);

    let html;
    if (props.selectedElement) {
      html = _.get(props.selectedElement, 'data.rawHTML');
    }
    this.state = {
      html
    };
  }

  componentWillReceiveProps(nextProps) {
    const {open, selectedElement } = nextProps;
    if (!this.state.open && open) {
      const html = _.get(selectedElement, 'data.rawHTML');
      this.setState({html});
    }
  }

  onHtmlChange = () => {
    this.setState({html: this.refs.htmlInput.value});
  };

  getElementProps() {
    return {
      data: {
        rawHTML: this.state.html,
      }
    };
  }

  render() {
    const {open, onCancel, onAddUpdate, selectedElement, newElement } = this.props;
    const {html} = this.state;

    return (
      <BaseElementDialog
        open={open}
        newElement={newElement}
        title={'Edit Link'}
        ref="baseElementDialog"
        inputValid
        onAddUpdate={() => onAddUpdate(this.getElementProps())}
        onCancel={() => onCancel()}
      >
        <div style={{width: '100%', margin: '20px auto', display: 'flex', alignItems: 'center', justifyContent: 'space-around'}}>
          <textarea defaultValue={html} ref="htmlInput" style={{width: 350, height: 350}} onChange={this.onHtmlChange}/>
          <div style={{width: 350, height: 350, border: '1px solid grey', overflowWrap: 'break-word', overflow: 'auto'}} dangerouslySetInnerHTML={{__html: html}}/>
        </div>
      </BaseElementDialog>);
  }
}
